module.exports = __webpack_public_path__ + "static/media/isdoctorplan-ent3.aab1c2ac.png";